import { useSelector } from "react-redux";

import { BudgetsStore } from "../_reducers/budgetsRootReducer";

// Only hides the writes: the backend rejects them on its own.
export function useIsReadOnlyEmployee() {
    const budgetUserState = useSelector(BudgetsStore.selectors.getBugetUser);
    return !!budgetUserState?.budgetUser?.readOnly;
}
